import useBrandTranslation from "../hooks/useBrandTranslation";

export default function MercadoPagoSuccess() {
  const { t } = useBrandTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 md:p-24">
      <h1 className="text-2xl font-bold text-green-600 mb-4">
        {t("app.payments.successTitle", "¡Pago Exitoso!")}
      </h1>
      <p className="text-lg text-gray-700 mb-8">
        {t(
          "app.payments.successBody",
          "Tu pago se ha completado exitosamente. Gracias por tu compra. Si tienes alguna pregunta, no dudes en contactarnos."
        )}
      </p>
      <a
        href="/"
        className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        {t("common.backToHome", "Volver al inicio")}
      </a>
    </main>
  );
}
